module.exports = __webpack_public_path__ + "img/10.d48f7840.png";